import Grid from "@mui/material/Grid";
import makeStyles from '@mui/styles/makeStyles';
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React,{useContext,useState} from "react";
import {AwardPill} from "./AwardPill";
import AddNewButton from "../../components/buttons/AddNewButton";
import  RankAwardModal from "../../components/modals/RankAwardModal";
import {AWARDS,getErrorMessage,post,RANKINGS} from "../../services/Client";
import {useSnackbar} from "notistack";
import {useQueryClient} from "react-query";
import {useGetRankingAwards} from "../../services/ContentManager";
import {AbilityContext} from "../../services/Can";
import {resources} from "../../services/ability";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    backButton: {
        color: theme.palette.primary.main,
    },
    backButtonIcon: {
        margin: theme.spacing(1)
    },
    container: {
        padding: "2rem",
        backgroundColor: theme.palette.primary.light,
        width: "auto"
    },
    addAward: {
        backgroundColor: theme.palette.primary.light,
        width: "100%",
        height: "100%",
    }
}));

/* Valori iniziali per la duplicazione di un premio classifica: copia i contenuti e
* ricostruisce posizione/intervallo dall'originale, impostando positionType coerente
* così il save() del modale azzera da solo il campo non pertinente (niente mix position/range).
*/ 
const buildCloneDefaults = (award) => {
    const base = {
        name: award.name,
        description: award.description,
        type: award.type,
        value: award.value,
        imageUrl: award.imageUrl,
    };
    if (award.range) {
        const [minPosition, maxPosition] = award.range.split('-').map(s => s.trim());
        return {...base, positionType: 1, minPosition, maxPosition, amount: award.amount};
    }
    return {...base, positionType: 0, position: award.position};
}

// Identità di una pill: gli intervalli si raggruppano per range, i premi a posizione singola
// stanno per conto loro (chiave = proprio id). È stabile anche quando cambiano i membri del
// gruppo o l'ordine restituito dal backend (che per i premi a pari valore è arbitrario):
// per questo è anche la `key` di React, altrimenti la pill verrebbe rimontata e si richiuderebbe.
const groupKeyOf = (award) => award.range || award.id;

export default function RankAward({ goBack, rank}) {

    const {t} = useTranslation();
    let classes = useStyles();
    const ability = useContext(AbilityContext);
    let [addAward, setAddAward] = useState(false);
    let [cloneSource, setCloneSource] = useState(null);
    let {awards = []} = useGetRankingAwards(rank.id);
    const {enqueueSnackbar} = useSnackbar();
    let queryClient = useQueryClient();
    const editable = ability.can('write', resources.RANKSAWARDS);

    const createAward = (values) => {
        let amount = Number.parseInt(values.amount) || 1;
        delete values.amount;
        values.ranking = rank.id;
        delete values.positionType;
        if(values.minPosition) values.range = values.minPosition + " - " + values.maxPosition
        delete values.minPosition
        delete values.maxPosition

        enqueueSnackbar(t('saving...'), {variant: "info"});
        for(let i = 0; i < amount; i++){
            let errors = 0;
            post(AWARDS +"/"+RANKINGS, {body: values})
                .then(() => i === amount-1 && errors === 0 && enqueueSnackbar(t('saved'), {variant: "success"}))
                .catch(e => {
                    enqueueSnackbar(getErrorMessage(e),{variant : "error"})
                    errors++
                })
                .finally(() => queryClient.invalidateQueries([AWARDS,{rid : rank.id}]))
        }
    }

    // Raggruppa SOLO i premi a intervallo (per range): sono N righe identiche create insieme.
    // I premi a posizione singola usano l'id come chiave => non vengono mai collassati/nascosti,
    // e modifica/elimina agiscono su un solo premio.
    // groupedAwards contiene i premi reali che compongono il gruppo: da lì si ricavano gli id
    // (per modifica/eliminazione), il conteggio e i vincitori, senza concatenare id in stringa.
    const getGrouped = (m, o) => {
        let key = groupKeyOf(o);
        let item = m.get(key);
        if (!item) return m.set(key, {...o, groupedAwards: [o]});
        item.groupedAwards.push(o);
        return m;
    };

    // amount = quanti premi ci sono nel gruppo (usato per la UI e come default in duplicazione)
    let collapsedAwards = Array.from(awards.reduce(getGrouped, new Map()).values())
        .map(a => ({...a, amount: a.groupedAwards.length}));

    collapsedAwards.sort((a,b) => {
        const positionA = Number.parseInt(a.position || a.range.substring(0, a.range.indexOf("-")-1))
        const positionB = Number.parseInt(b.position || b.range.substring(0, b.range.indexOf("-")-1))
        return positionA - positionB;
    })

    return (<Grid container justifyContent="space-between">
        <Grid container justifyContent="space-between">
            <Button onClick={goBack} className={classes.backButton}>
                <ArrowBackIcon className={classes.backButtonIcon}/>
                {t('goBack')}
            </Button>
            {editable && <AddNewButton text={t('addAward')} onClick={() => setAddAward(true)}/>}
        </Grid>
        <Grid container xs={12} className={classes.container}>

                {
                    collapsedAwards.map(award => <Grid item lg={6} xs={12} key={groupKeyOf(award)}>
                        <AwardPill award={award} editable={editable} rankId={rank.id}
                                   onClone={editable ? () => setCloneSource(award) : undefined}/>
                    </Grid>)
                }

            </Grid>
            <RankAwardModal open={!!addAward} onClose={() => setAddAward(false)} onSubmit={createAward}/>
            <RankAwardModal open={!!cloneSource} onClose={() => setCloneSource(null)} onSubmit={createAward}
                            defaultValues={cloneSource ? buildCloneDefaults(cloneSource) : {}}/>
        </Grid>
    );
}
